import { readLanguage } from '@/lib/language'

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * İNTERFEYS TƏRCÜMƏSİ — iOS `Localization.swift` və Android `Localization.kt` əkizi
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * Sahib tələbi (2026-08-03): «tv üçün ui tərcümələrini tam düzəlt bütün tv
 * projelərində». Əvvəl bu app-da tərcümə ÜMUMİYYƏTLƏ yox idi — dil seçimi yalnız
 * API məzmununu (`lang=`) dəyişirdi, düymələr isə Azərbaycanca qalırdı.
 *
 * ⚠ NİYƏ AZ-AÇAR (ayrıca `home.title` kimi açar adları deyil): telefon app-larında
 *   artıq bu model var — Azərbaycanca mətnin ÖZÜ açardır. Kod oxunaqlı qalır
 *   (`T('Profil')`), açar tapılmasa Azərbaycanca qaytarılır, yəni tərcüməsi
 *   yazılmamış sətir EKRANDA İTMİR. Üç səthdə eyni model olması vacibdir: eyni
 *   cümlə üç faylda eyni açarla axtarılır.
 *
 * ⚠ EKRAN YENİDƏN QURULMALIDIR. Bu app-da DOM bir dəfə qurulur (PERFORMANCE.md —
 *   sıfır reaktivlik), ona görə dil dəyişəndə mətnlər ÖZ-ÖZÜNƏ yenilənmir.
 *   `profile.ts` seçimdən sonra ekranı yenidən mount edir; qalan ekranlar onsuz da
 *   növbəti açılışda yeni dildə qurulur.
 *
 * ⚠ ES2015 HƏDDİ (PERFORMANCE.md): `Object.entries`, `??`, `?.` İŞLƏDİLMİR —
 *   webOS 3 (Chrome 38) onları tanımır.
 */

type Entry = [string, string, string, string]

/** Azərbaycanca mətn → [en, ru, tr, de]. Alman dili 2026-09-25-də əlavə olundu (sahib tələbi). */
const DICT: { [key: string]: Entry } = {
  'Abunə ol və ya filmi al': ['Subscribe or rent this film', 'Подписаться или арендовать фильм', 'Abone ol veya filmi kirala', 'Abonnieren oder Film ausleihen'],
  'Telefonla skan et və eyni hesabla daxil ol': ['Scan with your phone and sign in to the same account', 'Отсканируйте телефоном и войдите в тот же аккаунт', 'Telefonla tarayın ve aynı hesapla giriş yapın', 'Mit dem Handy scannen und mit demselben Konto anmelden'],
  'Ödənişdən sonra yenidən yoxla': ['Check again after payment', 'Проверить после оплаты', 'Ödemeden sonra tekrar kontrol et', 'Nach der Zahlung erneut prüfen'],
  // ── Naviqasiya · ortaq ──
  Əsas: ['Home', 'Главная', 'Ana sayfa', 'Start'],
  Kolleksiyalar: ['Collections', 'Коллекции', 'Koleksiyonlar', 'Sammlungen'],
  Canlı: ['Live', 'Эфир', 'Canlı', 'Live'],
  Axtarış: ['Search', 'Поиск', 'Arama', 'Suche'],
  Profil: ['Profile', 'Профиль', 'Profil', 'Profil'],
  Ətraflı: ['Details', 'Подробнее', 'Ayrıntılar', 'Details'],
  'Yüklənir…': ['Loading…', 'Загрузка…', 'Yükleniyor…', 'Wird geladen…'],
  'Yenidən cəhd et': ['Try again', 'Повторить', 'Tekrar dene', 'Erneut versuchen'],
  'Ana ekrana qayıt': ['Back to home', 'На главную', 'Ana ekrana dön', 'Zurück zum Start'],
  Təmizlə: ['Clear', 'Очистить', 'Temizle', 'Löschen'],
  Boşluq: ['Space', 'Пробел', 'Boşluk', 'Leerzeichen'],
  Uşaq: ['Kids', 'Детский', 'Çocuk', 'Kinder'],
  Çıxış: ['Sign out', 'Выйти', 'Çıkış', 'Abmelden'],
  ' dəq': [' min', ' мин', ' dk', ' Min.'],
  // Film səhifəsinin TAM müddət forması (hover qısaldılmışdan fərqli — MYTasks 527
  // yalnız hover üçündür). Aparıcı boşluq rəqəmlə bitişik yazılışdandır: `2 + T(' saat')`.
  ' saat': [' hr', ' ч', ' sa', ' Std.'],
  ' saat ': [' hr ', ' ч ', ' sa ', ' Std. '],
  'Tezliklə': ['Coming soon', 'Скоро', 'Yakında', 'Demnächst'],
  'daha çox': ['more', 'ещё', 'daha fazla', 'mehr'],
  // Yaş bloku modalının başlığı (530) — uzun izah mətnləri aşağıda ayrıca açarlardır.
  'Bu kontent yaş həddlidir': [
    'This title is age restricted',
    'Этот контент имеет возрастное ограничение',
    'Bu içerik yaş sınırlıdır',
    'Dieser Inhalt hat eine Altersbeschränkung',
  ],
  // ⚠ SAATIN BAŞ HƏRFİ — açar bir hərfdir, çünki ekrandakı mətn də bir hərfdir
  //   (sahib tələbi 2026-08-06, MYTasks 482: «hoverdə saat yox s yazılsın, hour
  //   yox h»). Dəyərlər saytdakı `hoursLetter` ilə eynidir; kart fokus qatında
  //   «1s 40 dəq» kimi çıxır. Tam söz («1 saat 40 dəq») detal ekranında qalır.
  s: ['h', 'ч', 's', 'h'],
  ' və ya ': [' or ', ' или ', ' veya ', ' oder '],
  'Səbəb: ': ['Reason: ', 'Причина: ', 'Sebep: ', 'Grund: '],

  // ── Ana ekran · kataloq ──
  'Kataloq hələ boşdur': ['The catalogue is empty', 'Каталог пуст', 'Katalog henüz boş', 'Der Katalog ist noch leer'],
  'Cihaz Kinobox serverinə qoşula bilmədi və ya kataloqda hələ məzmun yoxdur. ': [
    'The device could not reach the Kinobox server, or there is no content yet. ',
    'Устройство не смогло подключиться к серверу Kinobox, либо в каталоге ещё нет контента. ',
    'Cihaz Kinobox sunucusuna bağlanamadı ya da katalogda henüz içerik yok. ',
    'Das Gerät konnte den Kinobox-Server nicht erreichen, oder der Katalog ist noch leer. ',
  ],
  'İnternet bağlantısını yoxlayıb yenidən cəhd edin.': [
    'Check your internet connection and try again.',
    'Проверьте подключение к интернету и повторите попытку.',
    'İnternet bağlantınızı kontrol edip tekrar deneyin.',
    'Prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
  ],
  'Kinobox seçimi': ['Kinobox picks', 'Выбор Kinobox', 'Kinobox seçkisi', 'Kinobox-Auswahl'],
  'Davam et': ['Continue watching', 'Продолжить просмотр', 'İzlemeye devam et', 'Weiter'],

  // ── Uşaq profili — ana ekran (2026-08-26) ────────────────────────────────
  // ⚠ Janr adları burada SABİTDİR (`screens/kidsHome.ts` ağ siyahısı): veb TV-də ekran
  //   sinxron qurulur və janr sorğusu gözlənilmir (səbəbi orada yazılıb).
  // ⚠ Tərcümələr iOS `Localization.swift` və Android `Localization.kt` ilə EYNİDİR.
  'Salam!': ['Hi!', 'Привет!', 'Merhaba!', 'Hallo!'],
  'Salam, {name}!': ['Hi, {name}!', 'Привет, {name}!', 'Merhaba, {name}!', 'Hallo, {name}!'],
  'Bu gün nə baxırıq?': ['What shall we watch today?', 'Что посмотрим сегодня?', 'Bugün ne izliyoruz?', 'Was schauen wir heute?'],
  'Nə baxaq?': ['What to watch?', 'Что посмотреть?', 'Ne izleyelim?', 'Was schauen wir?'],
  'Hələ film yoxdur': ['No films yet', 'Фильмов пока нет', 'Henüz film yok', 'Noch keine Filme'],
  'Sənin üçün filmlər hazırlanır. Tezliklə burada olacaq.': [
    'Films are being prepared for you. They will be here soon.',
    'Фильмы для тебя готовятся. Скоро они появятся здесь.',
    'Senin için filmler hazırlanıyor. Yakında burada olacak.',
    'Filme werden für dich vorbereitet. Sie sind bald hier.',
  ],
  'Cizgi filmləri': ['Cartoons', 'Мультфильмы', 'Çizgi filmler', 'Zeichentrick'],
  'Macəra': ['Adventure', 'Приключения', 'Macera', 'Abenteuer'],
  'Komediya': ['Comedy', 'Комедия', 'Komedi', 'Komödie'],
  'Tarixi': ['Historical', 'Исторические', 'Tarihi', 'Historisch'],
  'İdman': ['Sport', 'Спорт', 'Spor', 'Sport'],
  'Sənədli': ['Documentary', 'Документальные', 'Belgesel', 'Dokumentation'],
  // «Sonra İzlə» sırası + siyahı ekranı (522) — dəyərlər Android `Localization.kt`-dən.
  // ⚠ YAZILIŞ 2026-08-30-DA DÜZƏLDİLDİ (sahib tələbi: «veb tv-də sonra bax yox,
  //   sonra izlə olmalıdır»). Açar da, çağırış yerləri də BİRLİKDƏ dəyişdi —
  //   `tests/i18n.test.ts` işlənən hər açarın lüğətdə olmasını tələb edir.
  //   Kanonik forma böyük nöqtəli «İ» ilədir: iOS `Localization.swift` və Android
  //   `Localization.kt` eyni açarı işlədir (üç səthdə eyni cümlə, eyni açar).
  'Sonra İzlə': ['Watch later', 'Смотреть позже', 'Sonra izle', 'Später ansehen'],
  'Ən çox baxılanlar': ['Most watched', 'Самые просматриваемые', 'En çok izlenenler', 'Meistgesehen'],
  'Siyahı boşdur': ['The list is empty', 'Список пуст', 'Liste boş', 'Die Liste ist leer'],
  'Bu bölmədə hələ kontent yoxdur.': [
    'There is no content in this section yet.',
    'В этом разделе пока нет контента.',
    'Bu bölümde henüz içerik yok.',
    'In diesem Bereich gibt es noch keine Inhalte.',
  ],
  // Hero «İzlə» pərdəsi (Android `TvHomeScreen` → `starting` bayrağı).
  'Açılır…': ['Opening…', 'Открывается…', 'Açılıyor…', 'Wird geöffnet…'],
  '▶  İzlə': ['▶  Watch', '▶  Смотреть', '▶  İzle', '▶  Ansehen'],
  // Hero-nun film variantı (sahib maketi 2026-08-11). Serial/tamaşa/konsertdə
  // yuxarıdakı neytral forma qalır — «Filmi izlə» orada yanlış olardı.
  '▶  Filmi İzlə': ['▶  Watch film', '▶  Смотреть фильм', '▶  Filmi izle', '▶  Film ansehen'],
  '+  Sonra İzlə': ['+  Watch later', '+  Смотреть позже', '+  Sonra izle', '+  Später ansehen'],
  '✓  Siyahımdadır': ['✓  In my list', '✓  В моём списке', '✓  Listemde', '✓  In meiner Liste'],
  // ⚠ Simvol AÇARIN İÇİNDƏDİR (qonşu düymələrdəki kimi): ayrı saxlansaydı hər
  //   çağırış yerində birləşdirmə yazılmalı, aralıqdakı iki boşluq isə asanlıqla
  //   itirilərdi. Türkcədə «Fragman» işlədilir — «Treyler» türkcə deyil.
  '▷  Treyler': ['▷  Trailer', '▷  Трейлер', '▷  Fragman', '▷  Trailer'],
  // ⚠ Film modalının aksiya düyməsi (`ui/detailModal.ts`, M2). Hero-dakı «▶  İzlə»
  //   AYRI açardır: orada kontekst onsuz da filmin öz kadrıdır, modalda isə düymə
  //   treylerin üstündədir və «nəyi izləyirəm — treylerimi, filmi?» sualı yaranır.
  //   2026-08-06 sahib tələbi ilə mətn «İndi izlə»dir (Android modalı ilə eyni açar);
  //   «▶» simvolu artıq açarda deyil — düymə SVG ikonludur.
  'İndi izlə': ['Watch now', 'Смотреть сейчас', 'Şimdi izle', 'Jetzt ansehen'],
  // Modalın sağ-üst «Bağla» düyməsi (522) — Android açarının eynisi.
  Bağla: ['Close', 'Закрыть', 'Kapat', 'Schließen'],
  // ⚠ Brauzer modalının yalnız-ikon düyməsinin `aria-label`-i (`browser/detailModal.ts`).
  //   Cihaz modalında etiket YOXDUR — orada ekran oxuyucusu da yoxdur, brauzerdə isə var.
  'Tam ekran': ['Fullscreen', 'Полный экран', 'Tam ekran', 'Vollbild'],
  Geri: ['Back', 'Назад', 'Geri', 'Zurück'],
  Bax: ['Watch', 'Смотреть', 'İzle', 'Ansehen'],
  Seanslar: ['Sessions', 'Сеансы', 'Seanslar', 'Vorführungen'],
  // Player başlığındakı «Treyler · Film adı» prefiksi (simvolsuz variant).
  Treyler: ['Trailer', 'Трейлер', 'Fragman', 'Trailer'],
  '● CANLI': ['● LIVE', '● ПРЯМОЙ ЭФИР', '● CANLI', '● LIVE'],
  'Telefonunla daxil ol': ['Sign in with your phone', 'Войдите с телефона', 'Telefonunla giriş yap', 'Mit dem Smartphone anmelden'],
  '← Sil': ['← Delete', '← Удалить', '← Sil', '← Löschen'],

  // ── Film səhifəsi ──
  // ⚠ Açar 2026-08-08-də «Oxşar məzmun»dan dəyişdi (MYTasks 571) — bölmə həm
  //   modalda, həm film səhifəsində EYNİ adı daşıyır.
  'Oxşar filmlər': ['Similar movies', 'Похожие фильмы', 'Benzer filmler', 'Ähnliche Titel'],
  'Rollarda: ': ['Cast: ', 'В ролях: ', 'Rollerde: ', 'Mit: '],
  // ⚠ İKİ NÖQTƏSİZ VARİANTLAR — «Tezliklə» modalının heyət sətri (MYTasks 709)
  //   etiketi ilə dəyəri ÖZÜ birləşdirir (`T('Rejissor') + ': ' + …`), çünki
  //   sətirdə iki etiket bir yerdədir və ayırıcı aralarındadır.
  'Rejissor': ['Director', 'Режиссёр', 'Yönetmen', 'Regie'],
  'Rollarda': ['Cast', 'В ролях', 'Rollerde', 'Mit'],
  Bölümlər: ['Episodes', 'Серии', 'Bölümler', 'Folgen'],
  // ── Filmin sonluq qatı (V064) ──
  //    ⚠ Üç açar da 2026-08-22-də əlavə olundu: qat yazılanda lüğətə salınmayıb, yəni
  //    sonluq ekranı dörd dildə də azərbaycanca çıxırdı (eyni boşluq iOS-da da vardı,
  //    orada tvOS örtük testi tutdu). Mətnlər Android və iOS lüğətləri ilə eynidir.
  'Bu filmi qiymətləndirin': ['Rate this film', 'Оцените фильм', 'Bu filmi puanlayın', 'Bewerten Sie diesen Film'],
  'Bunu da izləyin': ['Watch next', 'Смотрите также', 'Bunu da izleyin', 'Als Nächstes ansehen'],
  'Təşəkkür edirik': ['Thanks for rating', 'Спасибо за оценку', 'Puanın için teşekkürler', 'Danke für die Bewertung'],
  // ⚠ «Sənin üçün» DEYİL: kataloqda məhz bu adla film var (`senin-ucun`).
  'Sizin üçün seçilənlər': ['Picked for you', 'Подборка для вас', 'Sizin için seçilenler', 'Für Sie ausgewählt'],
  '-ci bölüm': [' episode', '-я серия', '. bölüm', '. Folge'],
  'Təsvir hələ əlavə olunmayıb.': [
    'No description yet.',
    'Описание пока не добавлено.',
    'Açıklama henüz eklenmedi.',
    'Noch keine Beschreibung.',
  ],
  'Bu məzmun açıla bilmədi': ['This content could not be opened', 'Не удалось открыть контент', 'Bu içerik açılamadı', 'Dieser Inhalt konnte nicht geöffnet werden'],
  '» üçün məlumat alınmadı. Ana ekrana qayıdıb yenidən cəhd edin.': [
    '» could not be loaded. Go back to the home screen and try again.',
    '» не удалось загрузить. Вернитесь на главную и попробуйте снова.',
    '» için bilgi alınamadı. Ana ekrana dönüp tekrar deneyin.',
    '» konnte nicht geladen werden. Gehen Sie zum Startbildschirm zurück und versuchen Sie es erneut.',
  ],

  // ── Kəşf (kataloq) ──
  Kəşf: ['Browse', 'Каталог', 'Keşfet', 'Entdecken'],
  Kataloq: ['Catalog', 'Каталог', 'Katalog', 'Katalog'],
  Hamısı: ['All', 'Все', 'Tümü', 'Alle'],
  'Bütün janrlar': ['All genres', 'Все жанры', 'Tüm türler', 'Alle Genres'],
  Film: ['Film', 'Фильм', 'Film', 'Film'],
  Serial: ['Series', 'Сериал', 'Dizi', 'Serie'],
  Tamaşa: ['Theatre', 'Спектакль', 'Tiyatro', 'Theater'],
  Konsert: ['Concert', 'Концерт', 'Konser', 'Konzert'],
  // Hero-nun səs düyməsi (2026-08-22, brauzer variantı saytdakı maketə keçdi).
  // Mətnlər saytdakı `heroMute`/`heroUnmute` ilə eynidir.
  'Səsi aç': ['Unmute', 'Включить звук', 'Sesi aç', 'Ton an'],
  'Səsi bağla': ['Mute', 'Выключить звук', 'Sesi kapat', 'Sprachchat beenden'],
  Sıfırla: ['Reset', 'Сбросить', 'Sıfırla', 'Zurücksetzen'],
  'Kataloq yüklənmədi.': [
    'The catalogue could not be loaded.',
    'Не удалось загрузить каталог.',
    'Katalog yüklenemedi.',
    'Der Katalog konnte nicht geladen werden.',
  ],
  'Bu filtrə uyğun nəticə yoxdur.': [
    'Nothing matches this filter.',
    'По этому фильтру ничего нет.',
    'Bu filtreye uygun sonuç yok.',
    'Keine Treffer für diesen Filter.',
  ],
  // ⚠ «növ və ya» hissəsi düşdü: Kəşfdə növ çipləri artıq yoxdur (2026-08-11,
  //   yerində kolleksiya düymələri var) — mətn olmayan filtrə yönləndirməməlidir.
  'Başqa janr seçin.': [
    'Pick a different genre.',
    'Выберите другой жанр.',
    'Başka bir janr seçin.',
    'Wählen Sie ein anderes Genre.',
  ],

  // ── Tezliklə (MYTasks 528) ──
  // «Tezliklə» açarının özü yuxarıda, naviqasiya blokundadır.
  // Premyera etiketi və boş-vəziyyət mətnləri saytdakı `premiere`/`upcomingEmpty`
  // lüğət sətirləri ilə EYNİDİR — üç səthdə eyni sözlər.
  Premyera: ['Premiere', 'Премьера', 'Prömiyer', 'Premiere'],
  'Hazırda elan olunmuş premyera yoxdur.': [
    'No premieres announced yet.',
    'Пока нет объявленных премьер.',
    'Şu anda duyurulmuş prömiyer yok.',
    'Derzeit keine angekündigten Premieren.',
  ],
  'Yeni filmlər plana düşən kimi burada görünəcək.': [
    'New titles will show up here as soon as they are scheduled.',
    'Новые фильмы появятся здесь, как только их поставят в план.',
    'Yeni filmler plana girer girmez burada görünecek.',
    'Neue Titel erscheinen hier, sobald sie geplant sind.',
  ],

  // ── Axtarış ──
  'Film və ya serial adı': ['Film or series title', 'Название фильма или сериала', 'Film veya dizi adı', 'Film- oder Serientitel'],
  'Axtarılır…': ['Searching…', 'Поиск…', 'Aranıyor…', 'Suche läuft…'],
  'Ən azı 2 hərf yazın.': ['Enter at least 2 letters.', 'Введите минимум 2 буквы.', 'En az 2 harf yazın.', 'Geben Sie mindestens 2 Buchstaben ein.'],
  '» üzrə nəticə tapılmadı.': ['» returned no results.', '» — ничего не найдено.', '» için sonuç bulunamadı.', '» ergab keine Treffer.'],

  // ── Canlı ──
  'Yayım yoxdur': ['No broadcast', 'Нет эфира', 'Yayın yok', 'Keine Sendung'],
  'Canlı yayım hazırlana bilmədi.': [
    'The live stream could not be prepared.',
    'Не удалось подготовить прямой эфир.',
    'Canlı yayın hazırlanamadı.',
    'Der Live-Stream konnte nicht vorbereitet werden.',
  ],
  'Canlı yayıma baxış üçün abunə olun (telefonda və ya saytda).': [
    'Subscribe to watch live (on your phone or the website).',
    'Оформите подписку, чтобы смотреть эфир (в телефоне или на сайте).',
    'Canlı yayını izlemek için abone olun (telefonda veya sitede).',
    'Abonnieren Sie, um live zu schauen (auf dem Smartphone oder der Website).',
  ],
  'Bu günün proqramı:': ["Today's schedule:", 'Программа на сегодня:', 'Bugünün programı:', 'Heutiges Programm:'],
  'Bu gün üçün proqram yoxdur.': ['No schedule for today.', 'На сегодня программы нет.', 'Bugün için program yok.', 'Kein Programm für heute.'],
  'Hazırda cədvəldə proqram yoxdur.': [
    'There is nothing scheduled right now.',
    'Сейчас в расписании ничего нет.',
    'Şu anda programda bir şey yok.',
    'Derzeit ist nichts geplant.',
  ],
  'Növbəti: ': ['Next: ', 'Далее: ', 'Sıradaki: ', 'Weiter: '],
  ' · Növbəti: ': [' · Next: ', ' · Далее: ', ' · Sıradaki: ', ' · Weiter: '],

  // ── Seanslar ──
  'Hazırda planlı seans yoxdur': [
    'No scheduled sessions right now',
    'Сейчас нет запланированных сеансов',
    'Şu anda planlı seans yok',
    'Derzeit keine geplanten Vorführungen',
  ],
  'Planlı canlı seanslar — bilet al, təyin olunan vaxtda birlikdə izlə.': [
    'Scheduled live sessions — buy a ticket and watch together at the set time.',
    'Запланированные сеансы — купите билет и смотрите вместе в назначенное время.',
    'Planlı canlı seanslar — bilet alın, belirlenen saatte birlikte izleyin.',
    'Geplante Live-Vorführungen – Ticket kaufen und zur festgelegten Zeit gemeinsam schauen.',
  ],
  Planlaşdırılıb: ['Scheduled', 'Запланировано', 'Planlandı', 'Geplant'],
  'Biletlər bitib': ['Sold out', 'Билеты закончились', 'Biletler tükendi', 'Ausverkauft'],
  /* ⚠ İKİSİ DƏ 2026-08-30-DA ƏLAVƏ OLUNDU: seans sətrinin statusu və qiyməti
     `screens/sessions.ts`-də ÇILPAQ yazılırdı, yəni dörd dildə də azərbaycanca
     çıxırdı (örtük testi onları görmürdü — sətir `el()`-ə DƏYİŞƏN kimi gedir). */
  'Biletiniz var': ['You have a ticket', 'У вас есть билет', 'Biletiniz var', 'Sie haben ein Ticket'],
  Pulsuz: ['Free', 'Бесплатно', 'Ücretsiz', 'Kostenlos'],
  'Canlı seans hazırlanır…': ['Preparing the session…', 'Сеанс готовится…', 'Seans hazırlanıyor…', 'Die Vorführung wird vorbereitet…'],

  // ── Profil ──
  Hesab: ['Account', 'Аккаунт', 'Hesap', 'Konto'],
  Cihaz: ['Device', 'Устройство', 'Cihaz', 'Gerät'],
  'Giriş rejimi': ['Sign-in mode', 'Режим входа', 'Giriş modu', 'Anmeldemodus'],
  'Aktiv profil': ['Active profile', 'Активный профиль', 'Aktif profil', 'Aktives Profil'],
  Dil: ['Language', 'Язык', 'Dil', 'Sprache'],
  'Profil dəyiş': ['Switch profile', 'Сменить профиль', 'Profil değiştir', 'Profil wechseln'],
  'Cihazı yenidən bağla': ['Re-link this device', 'Привязать устройство заново', 'Cihazı yeniden bağla', 'Gerät erneut verbinden'],
  'Giriş yoxdur': ['Not signed in', 'Вход не выполнен', 'Giriş yok', 'Nicht angemeldet'],
  'Mock (nümayiş)': ['Mock (demo)', 'Мок (демо)', 'Mock (demo)', 'Mock (Demo)'],
  // ⚠ Qonşu «Mock (nümayiş)» tərcümə olunurdu, bu isə YOX (2026-08-30) — eyni
  //   sətirdə bir dəyər tərcümə olunub, o biri olunmamış qalırdı.
  'Real (QR)': ['Real (QR)', 'Реальный (QR)', 'Gerçek (QR)', 'Real (QR)'],
  /* ⚠ CİHAZ ADININ EHTİYAT DƏYƏRİ (`lib/session.ts` → `deviceLabel`).
     ⚠ YALNIZ EKRANDA TƏRCÜMƏ OLUNUR: eyni dəyər QR başlanğıcında `deviceName`
       kimi SERVERƏ də gedir və ORA tərcüməsiz getməlidir — əks halda telefondakı
       və saytdakı cihaz siyahısında eyni televizor dilə görə fərqli adla görünərdi.
     ⚠ «Samsung TV»/«LG TV» lüğətdə YOXDUR və olmamalıdır: onlar brend adıdır. */
  Televizor: ['TV', 'Телевизор', 'Televizyon', 'Fernseher'],
  'Kim baxır?': ['Who is watching?', 'Кто смотрит?', 'Kim izliyor?', 'Wer schaut?'],
  'Kim baxır? →': ['Who is watching? →', 'Кто смотрит? →', 'Kim izliyor? →', 'Wer schaut? →'],
  'Profillər yüklənir…': ['Loading profiles…', 'Загрузка профилей…', 'Profiller yükleniyor…', 'Profile werden geladen…'],
  'Baxış profili tapılmadı. Saytda və ya telefonda profil yaradıb yenidən daxil olun.': [
    'No viewing profile found. Create one on the website or your phone and sign in again.',
    'Профиль просмотра не найден. Создайте его на сайте или в телефоне и войдите снова.',
    'İzleme profili bulunamadı. Sitede veya telefonda profil oluşturup tekrar giriş yapın.',
    'Kein Zuschauerprofil gefunden. Erstellen Sie eines auf der Website oder dem Smartphone und melden Sie sich erneut an.',
  ],
  'Profillər alınmadı. Geri qayıdıb yenidən cəhd edin.': [
    'Profiles could not be loaded. Go back and try again.',
    'Не удалось загрузить профили. Вернитесь и попробуйте снова.',
    'Profiller alınamadı. Geri dönüp tekrar deneyin.',
    'Die Profile konnten nicht geladen werden. Gehen Sie zurück und versuchen Sie es erneut.',
  ],
  'Baxış profili seçilməyib': ['No viewing profile selected', 'Профиль просмотра не выбран', 'İzleme profili seçilmedi', 'Kein Zuschauerprofil ausgewählt'],
  'Profil bölməsindən profil seçin.': [
    'Pick a profile in the Profile section.',
    'Выберите профиль в разделе «Профиль».',
    'Profil bölümünden bir profil seçin.',
    'Wählen Sie ein Profil im Bereich Profil.',
  ],

  // ── QR girişi ──
  'Kod hazırlanır…': ['Preparing the code…', 'Код готовится…', 'Kod hazırlanıyor…', 'Code wird vorbereitet…'],
  'Telefonunda aşağıdakı ünvanı aç və kodu təsdiqlə': [
    'Open this address on your phone and confirm the code',
    'Откройте этот адрес на телефоне и подтвердите код',
    'Telefonunda şu adresi aç ve kodu onayla',
    'Öffne diese Adresse auf deinem Smartphone und bestätige den Code',
  ],
  /* ⚠ NÖMRƏLİ VƏ NÖMRƏSİZ VARİANT — İKİSİ DƏ LAZIMDIR, DUBLİKAT DEYİL:
       CİHAZ dərisi (`screens/qr.ts`, Tizen/webOS) nömrəni MƏTNİN İÇİNDƏ saxlayır
       və o deri DƏYİŞMİR (sahib qərarı: köhnə dizayn Tizen/LG üçün olduğu kimi
       qalır). BRAUZER dərisi isə nömrəni ayrıca nişana çıxardı (2026-08-12
       forma düzəlişi), yəni ona nömrəsiz açar lazımdır. Birini silsək o biri
       səth 4 dildə azərbaycanca görünərdi. */
  '1.  QR-i telefonunun kamerası ilə skan et': [
    '1.  Scan the QR with your phone camera',
    '1.  Отсканируйте QR камерой телефона',
    '1.  QR’ı telefon kameranla tara',
    '1.  Scanne den QR-Code mit der Kamera deines Smartphones',
  ],
  '2.  və ya ': ['2.  or ', '2.  или ', '2.  veya ', '2.  oder '],
  'QR-i telefonunun kamerası ilə skan et': [
    'Scan the QR with your phone camera',
    'Отсканируйте QR камерой телефона',
    'QR’ı telefon kameranla tara',
    'Scanne den QR-Code mit der Kamera deines Smartphones',
  ],
  'və ya ': ['or ', 'или ', 'veya ', 'oder '],
  ' ünvanını aç': [' — open this address', ' — откройте адрес', ' adresini aç', ' – öffne diese Adresse'],
  '3.  aşağıdakı kodu daxil edib təsdiqlə': [
    '3.  Enter the code below and confirm',
    '3.  Введите код ниже и подтвердите',
    '3.  Aşağıdaki kodu girip onayla',
    '3.  Gib den Code unten ein und bestätige',
  ],
  'Kod bir neçə dəqiqə sonra yenilənir.': [
    'The code refreshes in a few minutes.',
    'Код обновится через несколько минут.',
    'Kod birkaç dakika sonra yenilenir.',
    'Der Code wird in wenigen Minuten erneuert.',
  ],
  'Serverə qoşulmaq alınmadı.': [
    'Could not reach the server.',
    'Не удалось подключиться к серверу.',
    'Sunucuya bağlanılamadı.',
    'Keine Verbindung zum Server.',
  ],
  'Şəbəkə bərpa olunanda avtomatik yenidən cəhd ediləcək.': [
    'It will retry automatically once the network is back.',
    'Повторная попытка будет выполнена автоматически, когда сеть восстановится.',
    'Ağ geri geldiğinde otomatik olarak yeniden denenecek.',
    'Sobald das Netzwerk wieder da ist, wird automatisch erneut versucht.',
  ],
  'Tətbiqdən çıxmaq istəyirsiniz?': [
    'Do you want to exit the app?',
    'Выйти из приложения?',
    'Uygulamadan çıkmak istiyor musunuz?',
    'Möchten Sie die App beenden?',
  ],
  Bəli: ['Yes', 'Да', 'Evet', 'Ja'],
  Xeyr: ['No', 'Нет', 'Hayır', 'Nein'],
  'Yükləmə alınmadı.': ['Loading failed.', 'Не удалось загрузить.', 'Yükleme başarısız oldu.', 'Laden fehlgeschlagen.'],
  'Sessiyanın vaxtı bitib. OK düyməsi ilə cihazı QR kodla yenidən bağlayın.': [
    'The session has expired. Press OK to re-link the device with a QR code.',
    'Сессия истекла. Нажмите OK, чтобы заново привязать устройство по QR-коду.',
    'Oturum süresi doldu. OK ile cihazı QR kodla yeniden bağlayın.',
    'Die Sitzung ist abgelaufen. Drücken Sie OK, um das Gerät per QR-Code erneut zu verbinden.',
  ],
  'İzləmək üçün Profil bölməsindən QR ilə daxil olun.': [
    'Sign in with a QR code from the Profile section to watch.',
    'Чтобы смотреть, войдите по QR-коду в разделе «Профиль».',
    'İzlemek için Profil bölümünden QR ile giriş yapın.',
    'Melden Sie sich zum Ansehen per QR-Code im Bereich Profil an.',
  ],

  // ── Oynatma ──
  // ── Player: parametrlər paneli və növbəti bölüm (2026-08-04) ──
  'Növbəti bölüm': ['Next episode', 'Следующая серия', 'Sonraki bölüm', 'Nächste Folge'],
  // Əl ilə keçid uğursuz olanda cari bölüm DAVAM EDİR (522, Android F16 qaydası).
  'Növbəti bölüm açılmadı. Cari bölüm davam edir.': [
    "Couldn't open the next episode. The current one keeps playing.",
    'Не удалось открыть следующую серию. Текущая продолжает воспроизводиться.',
    'Sonraki bölüm açılamadı. Mevcut bölüm devam ediyor.',
    'Die nächste Folge konnte nicht geöffnet werden. Die aktuelle läuft weiter.',
  ],
  // ── Player: geri sayım · sarıma · mühərrik xətaları (MYTasks 547) ──
  // «Növbəti bölüm 5 san» sayımının düymələri — dəyərlər saytdakı `playNow`/`cancel`
  // açarları ilə eynidir (`apps/web/src/lib/i18n.ts`), üç səthdə eyni söz görünsün.
  'İndi oynat': ['Play now', 'Смотреть сейчас', 'Şimdi oynat', 'Jetzt abspielen'],
  'Ləğv et': ['Cancel', 'Отмена', 'İptal', 'Abbrechen'],
  // ⚠ Aparıcı boşluq rəqəmlə bitişik yazılışdandır (`5 + T(' san')` → «5 san»),
  //   eyni naxış `' dəq'` və `' saat'` açarlarındadır.
  ' san': [' s', ' с', ' sn', ' s'],
  // Mühərrik xətaları — Android `KinoboxPlayer.kt → playbackErrorMessage` cədvəlinin
  // qarşılığı; əvvəl hər xəta eyni ümumi cümləni verirdi.
  'Qorunan videonun lisenziyası alınmadı. Bir azdan yenidən cəhd edin.': [
    "Couldn't get the licence for this protected video. Try again shortly.",
    'Не удалось получить лицензию для защищённого видео. Повторите попытку позже.',
    'Korumalı videonun lisansı alınamadı. Biraz sonra tekrar deneyin.',
    'Die Lizenz für dieses geschützte Video konnte nicht abgerufen werden. Bitte versuchen Sie es in Kürze erneut.',
  ],
  'Şəbəkə bağlantısı kəsildi. İnterneti yoxlayıb yenidən cəhd edin.': [
    'The network connection dropped. Check your internet and try again.',
    'Соединение с сетью прервано. Проверьте интернет и повторите попытку.',
    'Ağ bağlantısı kesildi. İnterneti kontrol edip tekrar deneyin.',
    'Die Netzwerkverbindung wurde unterbrochen. Prüfen Sie Ihr Internet und versuchen Sie es erneut.',
  ],
  'Video mənbəyi tapılmadı.': [
    'The video source was not found.',
    'Источник видео не найден.',
    'Video kaynağı bulunamadı.',
    'Die Videoquelle wurde nicht gefunden.',
  ],
  'Video formatı bu cihazda oynadılmır.': [
    'This device cannot play the video format.',
    'Это устройство не воспроизводит формат видео.',
    'Bu cihaz video formatını oynatamıyor.',
    'Dieses Videoformat kann auf diesem Gerät nicht abgespielt werden.',
  ],
  'Video oynadılmadı. Yenidən cəhd edin.': [
    "The video didn't play. Try again.",
    'Видео не воспроизвелось. Повторите попытку.',
    'Video oynatılmadı. Tekrar deneyin.',
    'Das Video konnte nicht abgespielt werden. Bitte erneut versuchen.',
  ],
  Keyfiyyət: ['Quality', 'Качество', 'Kalite', 'Qualität'],
  Avtomatik: ['Automatic', 'Автоматически', 'Otomatik', 'Automatisch'],
  Altyazı: ['Subtitles', 'Субтитры', 'Altyazı', 'Untertitel'],
  Səs: ['Audio', 'Звук', 'Ses', 'Ton'],
  // Oynatma sürəti (0.5×…2×) — rəqəmlərin özü tərcümə olunmur, yalnız başlıq.
  Sürət: ['Speed', 'Скорость', 'Hız', 'Geschwindigkeit'],
  Söndür: ['Off', 'Выключить', 'Kapat', 'Aus'],
  Naməlum: ['Unknown', 'Неизвестно', 'Bilinmiyor', 'Unbekannt'],
  'Bu videoda əlavə seçim yoxdur': [
    'No extra options for this video',
    'Для этого видео нет дополнительных настроек',
    'Bu videoda ek seçenek yok',
    'Keine weiteren Optionen für dieses Video',
  ],
  'Video yüklənir…': ['Loading video…', 'Загрузка видео…', 'Video yükleniyor…', 'Video wird geladen…'],
  'Video hazırlanır…': ['Preparing the video…', 'Видео готовится…', 'Video hazırlanıyor…', 'Video wird vorbereitet…'],
  'Treyler yüklənir…': ['Loading trailer…', 'Загрузка трейлера…', 'Fragman yükleniyor…', 'Trailer wird geladen…'],
  'Qorunan oynadıcı yüklənir…': [
    'Loading the protected player…',
    'Загрузка защищённого плеера…',
    'Korumalı oynatıcı yükleniyor…',
    'Geschützter Player wird geladen…',
  ],
  'Geri düyməsi ilə çıx': ['Press Back to exit', 'Назад — выход', 'Geri tuşuyla çık', 'Mit Zurück beenden'],
  // Bildiriş blokundakı çıxış düyməsi — veb TV-də siçanla baxan üçün YEGANƏ çıxış yolu.
  '‹  Geri': ['‹  Back', '‹  Назад', '‹  Geri', '‹  Zurück'],
  'Daxil olun': ['Sign in', 'Войдите', 'Giriş yapın', 'Anmelden'],
  'Geri düyməsi ilə çıx · Enter oynat/dayandır': [
    'Back to exit · Enter to play/pause',
    'Назад — выход · Enter — пауза/воспроизведение',
    'Geri ile çık · Enter oynat/duraklat',
    'Zurück zum Beenden · Enter für Wiedergabe/Pause',
  ],
  // Player-in BÜTÜN idarəetmələri bir sətirdə (2026-08-03: «playerin özəllikləri
  // tam görünmür») — əvvəlki mətn sarımanı ümumiyyətlə qeyd etmirdi.
  'Enter oynat/dayandır · ← → 10 saniyə · Geri çıxış': [
    'Enter play/pause · ← → 10 seconds · Back to exit',
    'Enter — пауза/воспроизведение · ← → 10 секунд · Назад — выход',
    'Enter oynat/duraklat · ← → 10 saniye · Geri çık',
    'Enter Wiedergabe/Pause · ← → 10 Sekunden · Zurück zum Beenden',
  ],
  'Bu film olduğunuz ölkədə əlçatan deyil.': ['This film is not available in your country.', 'Этот фильм недоступен в вашей стране.', 'Bu film bulunduğunuz ülkede kullanılamıyor.', 'Dieser Film ist in Ihrem Land nicht verfügbar.'],
  'Oynatma hazır deyil': ['Playback is not ready', 'Воспроизведение не готово', 'Oynatma hazır değil', 'Wiedergabe nicht bereit'],
  'Oynatma kəsildi': ['Playback stopped', 'Воспроизведение прервано', 'Oynatma kesildi', 'Wiedergabe gestoppt'],
  'Oynatma mümkün olmadı': ['Playback failed', 'Не удалось воспроизвести', 'Oynatma başarısız', 'Wiedergabe fehlgeschlagen'],
  'Oynatma xətası': ['Playback error', 'Ошибка воспроизведения', 'Oynatma hatası', 'Wiedergabefehler'],
  // ⚠ Eyni anda baxış limiti (13 avqust 2026) — mətn saytdakı `playbackReplaced*`
  //   açarları ilə SÖZBƏSÖZ eynidir: istifadəçi eyni hadisəni iki səthdə iki cür
  //   oxumamalıdır.
  'Baxış başqa cihazda davam edir': [
    'Playback moved to another device',
    'Просмотр продолжается на другом устройстве',
    'İzleme başka cihazda devam ediyor',
    'Die Wiedergabe läuft auf einem anderen Gerät weiter',
  ],
  'Planınızda eyni anda icazə verilən ekran sayı doldu. Digər cihazda izləməni dayandırıb burada davam edə bilərsiniz.': [
    'Your plan reached its limit of simultaneous screens. Stop watching on the other device to continue here.',
    'Достигнут лимит одновременных экранов вашего плана. Остановите просмотр на другом устройстве, чтобы продолжить здесь.',
    'Planınızdaki aynı anda izleme ekranı sayısı doldu. Diğer cihazda izlemeyi durdurup burada devam edebilirsiniz.',
    'Die in Ihrem Tarif erlaubte Anzahl gleichzeitiger Bildschirme ist erreicht. Beenden Sie die Wiedergabe auf dem anderen Gerät, um hier fortzufahren.',
  ],
  'Video oynadıla bilmədi': ['The video could not be played', 'Не удалось воспроизвести видео', 'Video oynatılamadı', 'Das Video konnte nicht abgespielt werden'],
  'Video hazır deyil': ['Video not available', 'Видео недоступно', 'Video hazır değil', 'Video nicht verfügbar'],
  'Bu kontent üçün video hələ hazırlanmayıb.': [
    'The video for this title is not ready yet.',
    'Видео для этого контента ещё не готово.',
    'Bu içerik için video henüz hazırlanmadı.',
    'Das Video für diesen Titel ist noch nicht bereit.',
  ],
  'Bu ekran üçün nə film, nə treyler mənbəyi verilib.': [
    'Neither a film nor a trailer source was provided for this screen.',
    'Для этого экрана не задан ни фильм, ни трейлер.',
    'Bu ekran için ne film ne de fragman kaynağı verildi.',
    'Für diesen Bildschirm wurde weder eine Film- noch eine Trailerquelle angegeben.',
  ],
  'Video mənbəyinə çatmaq alınmadı.': [
    'The video source could not be reached.',
    'Не удалось получить источник видео.',
    'Video kaynağına ulaşılamadı.',
    'Die Videoquelle konnte nicht erreicht werden.',
  ],
  'Şəbəkə və ya mənbə xətası. Geri qayıdıb yenidən cəhd edin.': [
    'Network or source error. Go back and try again.',
    'Ошибка сети или источника. Вернитесь и попробуйте снова.',
    'Ağ veya kaynak hatası. Geri dönüp tekrar deneyin.',
    'Netzwerk- oder Quellenfehler. Gehen Sie zurück und versuchen Sie es erneut.',
  ],
  'Şəbəkə bərpa olunanda «Geri» ilə çıxıb yenidən açın.': [
    'When the network is back, press Back and open it again.',
    'Когда сеть восстановится, нажмите «Назад» и откройте снова.',
    'Ağ geri geldiğinde «Geri» ile çıkıp yeniden açın.',
    'Wenn das Netzwerk wieder da ist, drücken Sie Zurück und öffnen Sie es erneut.',
  ],
  ' — «Geri» ilə çıxıb yenidən açın.': [
    ' — press Back and open it again.',
    ' — нажмите «Назад» и откройте снова.',
    ' — «Geri» ile çıkıp yeniden açın.',
    ' – drücken Sie Zurück und öffnen Sie es erneut.',
  ],
  'Qorunan video dəstəklənmir': ['Protected video is not supported', 'Защищённое видео не поддерживается', 'Korumalı video desteklenmiyor', 'Geschützte Videos werden nicht unterstützt'],
  'Bu cihazda DRM oynatması mümkün olmadı.': [
    'DRM playback is not possible on this device.',
    'Воспроизведение с DRM на этом устройстве невозможно.',
    'Bu cihazda DRM oynatma mümkün olmadı.',
    'DRM-Wiedergabe ist auf diesem Gerät nicht möglich.',
  ],
  'Qorunan video oynadıla bilmədi (DRM və ya şəbəkə). Geri qayıdıb yenidən cəhd edin.': [
    'The protected video could not be played (DRM or network). Go back and try again.',
    'Не удалось воспроизвести защищённое видео (DRM или сеть). Вернитесь и попробуйте снова.',
    'Korumalı video oynatılamadı (DRM veya ağ). Geri dönüp tekrar deneyin.',
    'Das geschützte Video konnte nicht abgespielt werden (DRM oder Netzwerk). Gehen Sie zurück und versuchen Sie es erneut.',
  ],
  'Bu brauzer qorunan videonu oynada bilmir. Başqa brauzerdə (Chrome, Edge, Safari) açın.': [
    'This browser cannot play protected video. Try another browser (Chrome, Edge, Safari).',
    'Этот браузер не может воспроизвести защищённое видео. Откройте в другом браузере (Chrome, Edge, Safari).',
    'Bu tarayıcı korumalı videoyu oynatamıyor. Başka bir tarayıcıda (Chrome, Edge, Safari) açın.',
    'Dieser Browser kann geschützte Videos nicht abspielen. Versuchen Sie einen anderen Browser (Chrome, Edge, Safari).',
  ],
  'Bu televizorun brauzeri qorunan videonu oynada bilmir. Filmi Kinobox tətbiqində və ya başqa cihazda (telefon, kompüter) izləyin.': [
    'This TV browser cannot play protected video. Watch it in the Kinobox app or on another device (phone, computer).',
    'Браузер этого телевизора не может воспроизвести защищённое видео. Смотрите фильм в приложении Kinobox или на другом устройстве (телефон, компьютер).',
    'Bu televizyonun tarayıcısı korumalı videoyu oynatamıyor. Filmi Kinobox uygulamasında veya başka bir cihazda (telefon, bilgisayar) izleyin.',
    'Der Browser dieses Fernsehers kann geschützte Videos nicht abspielen. Sehen Sie den Film in der Kinobox-App oder auf einem anderen Gerät (Smartphone, Computer).',
  ],
  'Bu cihaz qorunan videonu oynada bilmir.': [
    'This device cannot play protected video.',
    'Это устройство не может воспроизвести защищённое видео.',
    'Bu cihaz korumalı videoyu oynatamıyor.',
    'Dieses Gerät kann das geschützte Video nicht abspielen.',
  ],
  'Qorunan video yüklənmədi.': [
    'The protected video did not load.',
    'Защищённое видео не загрузилось.',
    'Korumalı video yüklenmedi.',
    'Das geschützte Video wurde nicht geladen.',
  ],
  'Bu brauzer HLS-i dəstəkləmir. TV-də oynayır.': [
    'This browser does not support HLS. It plays on the TV.',
    'Этот браузер не поддерживает HLS. На телевизоре воспроизводится.',
    'Bu tarayıcı HLS desteklemiyor. TV’de oynatılıyor.',
    'Dieser Browser unterstützt kein HLS. Auf dem Fernseher funktioniert es.',
  ],
  'Treyler tapılmadı': ['Trailer not found', 'Трейлер не найден', 'Fragman bulunamadı', 'Trailer nicht gefunden'],
  'Treyler oynadıla bilmədi': ['The trailer could not be played', 'Не удалось воспроизвести трейлер', 'Fragman oynatılamadı', 'Der Trailer konnte nicht abgespielt werden'],
  'Bu məzmun üçün treyler mənbəyi yoxdur.': [
    'There is no trailer source for this title.',
    'Для этого контента нет трейлера.',
    'Bu içerik için fragman kaynağı yok.',
    'Für diesen Titel gibt es keine Trailerquelle.',
  ],
  'Treyler mənbəyi həll olunmadı.': [
    'The trailer source could not be resolved.',
    'Не удалось определить источник трейлера.',
    'Fragman kaynağı çözümlenemedi.',
    'Die Trailerquelle konnte nicht aufgelöst werden.',
  ],

  // ── Hüquq ──
  'Abunəlik lazımdır': ['Subscription required', 'Нужна подписка', 'Abonelik gerekli', 'Abonnement erforderlich'],
  'Yaş həddi': ['Age restricted', 'Возрастное ограничение', 'Yaş sınırı', 'Altersbeschränkung'],
  'Bu film hələ əlçatan deyil — hələlik yalnız treylerini izləyə bilərsiniz.': [
    'This film is not available yet — for now you can only watch the trailer.',
    'Фильм ещё не доступен — пока можно посмотреть только трейлер.',
    'Bu film henüz erişilebilir değil — şimdilik yalnızca fragmanını izleyebilirsiniz.',
    'Dieser Film ist noch nicht verfügbar – vorerst können Sie nur den Trailer sehen.',
  ],

  // ⚠ Bu ikisi `T()`-yə DƏYİŞƏN kimi gedir (`screens/player.ts` → `source.reason`),
  //   ona görə örtük testi onları tuta bilmir — əl ilə saxlanılır.
  'Vimeo treyleri hazırlanır…': [
    'Preparing the Vimeo trailer…',
    'Подготовка трейлера Vimeo…',
    'Vimeo fragmanı hazırlanıyor…',
    'Vimeo-Trailer wird vorbereitet…',
  ],
  'Naməlum treyler mənbəyi.': [
    'Unknown trailer source.',
    'Неизвестный источник трейлера.',
    'Bilinmeyen fragman kaynağı.',
    'Unbekannte Trailerquelle.',
  ],
  // ── Yaş qapısı: pultla doğum tarixi (MYTasks 530, 2-ci mərhələ) ──
  // 2026-08-05-dəki «TV-də tarix soruşulmur» qərarını sahib 2026-08-07-də
  // dəyişdi («saytda oldugu kimi düzəliş imkanı olsun») — köhnə «mobil
  // tətbiqdən və ya saytdan əlavə edin» açarı da buna görə silindi.
  // Etiketlər, ay adları və mətnlər saytdakı `DateSelect.tsx` və Android
  // `Localization.kt` ilə EYNİDİR.
  'Gün': ['Day', 'День', 'Gün', 'Tag'],
  'Ay': ['Month', 'Месяц', 'Ay', 'Monat'],
  'İl': ['Year', 'Год', 'Yıl', 'Jahr'],
  'Təsdiq et': ['Confirm', 'Подтвердить', 'Onayla', 'Bestätigen'],
  'Yadda saxlanılır…': ['Saving…', 'Сохранение…', 'Kaydediliyor…', 'Wird gespeichert…'],
  'Bu kontent yaş həddlidir. Davam etmək üçün doğum tarixinizi qeyd edin.': [
    'This title is age restricted. Add your date of birth to continue.',
    'Этот контент имеет возрастное ограничение. Укажите дату рождения, чтобы продолжить.',
    'Bu içerik yaş sınırlıdır. Devam etmek için doğum tarihinizi girin.',
    'Dieser Inhalt hat eine Altersbeschränkung. Geben Sie zum Fortfahren Ihr Geburtsdatum an.',
  ],
  'Doğum tarixi yadda saxlanmadı. Yenidən yoxlayın.': [
    'Could not save your date of birth. Please try again.',
    'Не удалось сохранить дату рождения. Попробуйте ещё раз.',
    'Doğum tarihi kaydedilemedi. Lütfen tekrar deneyin.',
    'Das Geburtsdatum konnte nicht gespeichert werden. Bitte erneut versuchen.',
  ],
  // ⚠ Ay adları `T()`-yə DƏYİŞƏN kimi gedir (`ui/detailModal.ts` → `MONTH_KEYS`),
  //   örtük testi onları tuta bilmir — əl ilə saxlanılır.
  'Yanvar': ['January', 'Январь', 'Ocak', 'Januar'],
  'Fevral': ['February', 'Февраль', 'Şubat', 'Februar'],
  'Mart': ['March', 'Март', 'Mart', 'März'],
  'Aprel': ['April', 'Апрель', 'Nisan', 'April'],
  'May': ['May', 'Май', 'Mayıs', 'Mai'],
  'İyun': ['June', 'Июнь', 'Haziran', 'Juni'],
  'İyul': ['July', 'Июль', 'Temmuz', 'Juli'],
  'Avqust': ['August', 'Август', 'Ağustos', 'August'],
  'Sentyabr': ['September', 'Сентябрь', 'Eylül', 'September'],
  'Oktyabr': ['October', 'Октябрь', 'Ekim', 'Oktober'],
  'Noyabr': ['November', 'Ноябрь', 'Kasım', 'November'],
  'Dekabr': ['December', 'Декабрь', 'Aralık', 'Dezember'],
  'Bu kontent yaş həddinə görə hesabınızda açılmır.': [
    'This title is blocked on your account because of its age rating.',
    'Этот контент недоступен в вашем аккаунте из-за возрастного ограничения.',
    'Bu içerik yaş sınırı nedeniyle hesabınızda açılmıyor.',
    'Dieser Inhalt kann wegen der Altersfreigabe in Ihrem Konto nicht geöffnet werden.',
  ],
  'Bölüm': [
    'Episode',
    'Серия',
    'Bölüm',
    'Folge',
  ],
  'Abunə olmaq və ya filmi almaq üçün mobil cihazdan və ya kompüterdən kinobox.az saytına daxil olun. Sonra TV-də eyni hesabla izləyə bilərsiniz.': [
    'To subscribe or buy this film, visit kinobox.az on your mobile device or computer. Then watch on TV with the same account.',
    'Чтобы оформить подписку или купить фильм, откройте kinobox.az на мобильном устройстве или компьютере. Затем смотрите на ТВ с того же аккаунта.',
    'Abone olmak veya filmi satın almak için mobil cihazınızdan ya da bilgisayarınızdan kinobox.az sitesine girin. Ardından aynı hesapla TV’de izleyebilirsiniz.',
    'Um ein Abonnement abzuschließen oder den Film zu kaufen, öffnen Sie kinobox.az auf Ihrem Mobilgerät oder Computer. Danach können Sie mit demselben Konto am Fernseher schauen.',
  ],
  'Bu filmə baxış hüququnuz yoxdur. Abunə və ya satınalma tələb olunur.': [
    'You do not have access to this title. A subscription or purchase is required.',
    'У вас нет доступа к этому фильму. Требуется подписка или покупка.',
    'Bu filme erişim hakkınız yok. Abonelik veya satın alma gerekiyor.',
    'Sie haben keinen Zugriff auf diesen Film. Ein Abonnement oder Kauf ist erforderlich.',
  ],
  ' İndi treyleri izləyə bilərsiniz.': [
    ' You can watch the trailer now.',
    ' Сейчас можно посмотреть трейлер.',
    ' Şimdi fragmanı izleyebilirsiniz.',
    ' Sie können jetzt den Trailer ansehen.',
  ],

  // ═══ BRAUZER VARİANTI (MYTasks 693 — `src/browser/*`) ══════════════════════
  // ⚠ AYRI LÜĞƏT DEYİL, EYNİ LÜĞƏT: iki hədəf eyni sözü eyni cür deməlidir.
  //   Cihaz app-ında olmayan sətirlər (işarəçi oxları, «Daha çox», axtarış
  //   sahəsinin ipucu) yalnız orada yoxdur — dil qatı bölünmür.
  // ⚠ HAZIRDA ÇAĞIRILMIR (2026-08-30): «Seçilmişlər» sırası ana ekrandan çıxarıldı —
  //   qalan hero-lara indi hero-nun ÖZ oxları ilə çatılır (`browser/screens/home.ts`).
  //   Açar SAXLANILIR: sıra geri qayıdarsa üç dildəki mətn hazır olsun və eyni söz
  //   ikinci dəfə başqa cür yazılmasın.
  Seçilmişlər: ['Featured', 'Избранное', 'Öne çıkanlar', 'Empfohlen'],
  'Sənin üçün': ['For you', 'Для вас', 'Sana özel', 'Für dich'],
  'Hamısı ›': ['See all ›', 'Все ›', 'Tümü ›', 'Alle ›'],
  /*
    ⚠⚠ «Daha çox» = MƏTNİ AÇAN düymə (Android `Localization.kt`-dəki eyni açar:
       More · Ещё · Daha fazla). Əvvəl bu sətir 'Load more' idi, çünki açarı ilk
       işlədən yer kataloqun SƏHİFƏLƏMƏ düyməsi olub — nəticədə uzun təsvirin
       açılış düyməsi ingiliscə «Load more» yazırdı (2026-08-13-də tutuldu).
       Səhifələmə indi öz açarındadır: «Daha çox göstər».
  */
  'Daha çox': ['More', 'Ещё', 'Daha fazla', 'Mehr'],
  // Kataloqun səhifələmə düyməsi (brauzer qabığı) — mətn açan düymə DEYİL.
  'Daha çox göstər': ['Load more', 'Показать ещё', 'Daha fazla', 'Mehr laden'],
  // ── Şəxs ekranı (2026-08-13, Android `TvPersonScreen` pariteti) ──────────
  'Şəxs': ['Person', 'Персона', 'Kişi', 'Person'],
  'Şəxslər': ['People', 'Персоны', 'Kişiler', 'Personen'],
  // Axtarış nəticəsində şəxs sırasından SONRAKI film şəbəkəsinin başlığı
  // (2026-08-16 — brauzer hədəfində şəxs sırası əlavə ediləndə lazım oldu).
  'Filmlər': ['Movies', 'Фильмы', 'Filmler', 'Filme'],
  Filmoqrafiya: ['Filmography', 'Фильмография', 'Filmografi', 'Filmografie'],
  'Filmoqrafiya boşdur': ['Filmography is empty', 'Фильмография пуста', 'Filmografi boş', 'Die Filmografie ist leer'],
  'Bu şəxsə bağlı dərc olunmuş kontent yoxdur.': [
    'There is no published content for this person.',
    'Опубликованного контента для этой персоны нет.',
    'Bu kişiye ait yayımlanmış içerik yok.',
    'Keine veröffentlichten Inhalte zu dieser Person.',
  ],
  // ⚠ «Daha çox»un cütü — uzun təsvir açılandan sonra onu geri yığır
  //   (`browser/ui.ts` → `webDescription`, sahib tələbi 2026-08-12).
  Gizlət: ['Show less', 'Свернуть', 'Gizle', 'Weniger anzeigen'],
  Axtar: ['Search', 'Найти', 'Ara', 'Suchen'],
  'Film, serial, aktyor…': ['Movie, series, actor…', 'Фильм, сериал, актёр…', 'Film, dizi, oyuncu…', 'Film, Serie, Schauspieler…'],
  'Ən azı iki hərf yaz.': ['Type at least two letters.', 'Введите хотя бы две буквы.', 'En az iki harf yazın.', 'Mindestens zwei Buchstaben eingeben.'],
  'Nəticə tapılmadı.': ['No results found.', 'Ничего не найдено.', 'Sonuç bulunamadı.', 'Keine Ergebnisse.'],
  'Bu filtrdə nəticə yoxdur.': [
    'No results for this filter.',
    'По этому фильтру ничего нет.',
    'Bu filtrede sonuç yok.',
    'Keine Ergebnisse für diesen Filter.',
  ],
  'Bu bölmə hələ boşdur.': ['This section is empty.', 'Этот раздел пока пуст.', 'Bu bölüm henüz boş.', 'Dieser Bereich ist noch leer.'],
  Siyahı: ['List', 'Список', 'Liste', 'Liste'],
  Oxşar: ['Similar', 'Похожие', 'Benzer', 'Ähnlich'],
  'Heyəti Gör': ['View Cast', 'Посмотреть состав', 'Oyuncu Kadrosunu Gör', 'Besetzung ansehen'],
  Heyət: ['Cast', 'В ролях', 'Oyuncular', 'Besetzung & Team'],
  'hazır deyil': ['not available', 'недоступно', 'hazır değil', 'nicht verfügbar'],
  'tarix açıqlanmayıb': ['date not announced', 'дата не объявлена', 'tarih açıklanmadı', 'Datum nicht bekannt gegeben'],
  'Bu günün proqramı': ["Today's schedule", 'Программа на сегодня', 'Bugünün programı', 'Heutiges Programm'],
  CANLI: ['LIVE', 'ЭФИР', 'CANLI', 'LIVE'],
  '▶  Bax': ['▶  Watch', '▶  Смотреть', '▶  İzle', '▶  Ansehen'],
  'Daxil ol': ['Sign in', 'Войти', 'Giriş yap', 'Anmelden'],
  'QR ilə bağla': ['Connect with QR', 'Подключить по QR', 'QR ile bağlan', 'Per QR verbinden'],
  'Geri sürüşdür': ['Scroll back', 'Прокрутить назад', 'Geri kaydır', 'Zurück scrollen'],
  'İrəli sürüşdür': ['Scroll forward', 'Прокрутить вперёд', 'İleri kaydır', 'Vorwärts scrollen'],
  // ⚠ SONDAKI BOŞLUQ AÇARIN BİR HİSSƏSİDİR: mətn `T('Bölüm ') + episode.number`
  //   kimi qurulur (rəqəm bitişik yazılmasın).
  'Bölüm ': ['Episode ', 'Серия ', 'Bölüm ', 'Folge '],
  'Bu material ': ['This title is ', 'Этот материал ', 'Bu içerik ', 'Dieser Titel ist '],
  '+ üçündür. Hesabındakı yaş uyğun deyil.': [
    '+ only. Your account age does not meet it.',
    '+ и старше. Возраст в аккаунте не подходит.',
    '+ içindir. Hesabınızdaki yaş uygun değil.',
    '+. Das Alter in deinem Konto reicht nicht aus.',
  ],
  'Yaş məhdudiyyəti': ['Age restriction', 'Возрастное ограничение', 'Yaş sınırı', 'Altersbeschränkung'],
  'Doğum tarixin': ['Your date of birth', 'Дата рождения', 'Doğum tarihin', 'Dein Geburtsdatum'],
  'Bu materialı açmaq üçün yaşını təsdiqlə.': [
    'Confirm your age to open this title.',
    'Подтвердите возраст, чтобы открыть этот материал.',
    'Bu içeriği açmak için yaşını doğrula.',
    'Bestätige dein Alter, um diesen Titel zu öffnen.',
  ],
  'Gün, ay və ili seç.': ['Pick day, month and year.', 'Выберите день, месяц и год.', 'Gün, ay ve yılı seçin.', 'Tag, Monat und Jahr wählen.'],
  Təsdiqlə: ['Confirm', 'Подтвердить', 'Onayla', 'Bestätigen'],
  'Yoxlanılır…': ['Checking…', 'Проверяем…', 'Kontrol ediliyor…', 'Wird geprüft…'],
  // PIN pad-ı — PIN-li profilə keçid (`screens/profiles.ts`).
  '«{name}» üçün PIN': ['PIN for “{name}”', 'PIN для «{name}»', '“{name}” için PIN', 'PIN für „{name}“'],
  '4 və ya 6 rəqəm': ['4 or 6 digits', '4 или 6 цифр', '4 veya 6 rakam', '4 oder 6 Ziffern'],
  'PIN yanlışdır. Yenidən yoxlayın.': [
    'Wrong PIN. Try again.',
    'Неверный PIN. Попробуйте снова.',
    'PIN yanlış. Tekrar deneyin.',
    'Die PIN ist falsch. Bitte erneut versuchen.',
  ],
  'Tarix qeyd olunmadı — hesabında artıq tarix var və ya şəbəkə xətası.': [
    'Date not saved — your account already has one, or the network failed.',
    'Дата не сохранена — она уже есть в аккаунте или ошибка сети.',
    'Tarih kaydedilmedi — hesabında zaten var ya da ağ hatası.',
    'Datum nicht gespeichert – dein Konto hat bereits eines, oder das Netzwerk ist ausgefallen.',
  ],
  'Məlumat tapılmadı.': ['Not found.', 'Ничего не найдено.', 'Bulunamadı.', 'Nicht gefunden.'],
  'Film açıla bilmədi. Bir azdan yenidən yoxlayın.': [
    'The title could not be opened. Try again shortly.',
    'Не удалось открыть фильм. Попробуйте позже.',
    'Film açılamadı. Birazdan tekrar deneyin.',
    'Der Titel konnte nicht geöffnet werden. Versuchen Sie es in Kürze erneut.',
  ],
  'Kataloq yüklənmədi. Bir azdan yenidən yoxlayın.': [
    'The catalog did not load. Try again shortly.',
    'Каталог не загрузился. Попробуйте позже.',
    'Katalog yüklenmedi. Birazdan tekrar deneyin.',
    'Der Katalog wurde nicht geladen. Versuchen Sie es in Kürze erneut.',
  ],
  'Siyahı yüklənmədi. Bir azdan yenidən yoxlayın.': [
    'The list did not load. Try again shortly.',
    'Список не загрузился. Попробуйте позже.',
    'Liste yüklenmedi. Birazdan tekrar deneyin.',
    'Die Liste wurde nicht geladen. Versuchen Sie es in Kürze erneut.',
  ],
  'Profillər yüklənmədi. Bir azdan yenidən yoxlayın.': [
    'Profiles did not load. Try again shortly.',
    'Профили не загрузились. Попробуйте позже.',
    'Profiller yüklenmedi. Birazdan tekrar deneyin.',
    'Die Profile wurden nicht geladen. Versuchen Sie es in Kürze erneut.',
  ],
  'Profil tapılmadı. Saytda və ya telefonda profil yaradın.': [
    'No profile found. Create one on the website or in the app.',
    'Профиль не найден. Создайте его на сайте или в приложении.',
    'Profil bulunamadı. Sitede veya telefonda profil oluşturun.',
    'Kein Profil gefunden. Erstellen Sie eines auf der Website oder in der App.',
  ],
  'Sessiya bitib. QR ilə yenidən bağlayın.': [
    'Session expired. Reconnect with the QR code.',
    'Сессия истекла. Подключитесь заново по QR.',
    'Oturum bitti. QR ile yeniden bağlanın.',
    'Sitzung abgelaufen. Verbinden Sie erneut per QR-Code.',
  ],
  'Hazırda planlaşdırılmış premyera yoxdur.': [
    'No premieres scheduled right now.',
    'Сейчас нет запланированных премьер.',
    'Şu anda planlanmış prömiyer yok.',
    'Derzeit keine geplanten Premieren.',
  ],
  'Şəbəkə bərpa olunanda səhifəni yeniləyin.': [
    'Refresh the page when the network is back.',
    'Обновите страницу, когда сеть восстановится.',
    'Ağ geri geldiğinde sayfayı yenileyin.',
    'Aktualisieren Sie die Seite, wenn das Netzwerk wieder da ist.',
  ],
  'yuxarıdakı kodu daxil edib təsdiqlə': [
    'enter the code above and confirm',
    'введите код выше и подтвердите',
    'yukarıdaki kodu girip onaylayın',
    'gib den Code oben ein und bestätige',
  ],
}

/**
 * Statik interfeys mətnini seçilmiş dildə qaytarır.
 * Açar lüğətdə yoxdursa (və ya dil `az`-dır) Azərbaycanca mətn qayıdır.
 */
export function T(az: string): string {
  const lang = readLanguage()
  if (lang === 'az') return az
  const entry = DICT[az]
  if (!entry) return az
  if (lang === 'ru') return entry[1]
  if (lang === 'tr') return entry[2]
  if (lang === 'de') return entry[3]
  return entry[0]
}

/** Testlər üçün: lüğətdəki açarların siyahısı. */
export function translationKeys(): string[] {
  const keys: string[] = []
  for (const key in DICT) {
    if (Object.prototype.hasOwnProperty.call(DICT, key)) keys.push(key)
  }
  return keys
}
